module.exports = __webpack_public_path__ + "static/img/07.8df5df3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/07.jpg
// module id = UhIL
// module chunks = 0